import React from 'react';
import { useDispatch } from 'react-redux';
import { logoutUser } from '.';

export default function useHandleLogoutUser() {
  const dispatch = useDispatch();
  return React.useCallback(() => dispatch(logoutUser()), [dispatch]);
}
